import React from "react";
import { Footer, NavBar } from "./components";
import { Route, Routes } from "react-router-dom";
import { Home, Login } from "./pages";

const App = () => {
  return (
    <>
      <NavBar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

export default App;
